import * as React from 'react'

import type { ButtonProps as ShadcnButtonProps } from '@/components/ui/button'
import { Button as ShadcnButton, buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'

type ButtonProps = ShadcnButtonProps

/**
 * Button wrapper component with cursor-pointer.
 *
 * The link variant is re-tinted here (text-link) instead of in ui/button:
 * upstream styles it text-primary, which is the Signater action yellow —
 * unreadable as text on light surfaces — and the ui layer stays unedited.
 */
const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, ...props }, ref) => {
    return (
      <ShadcnButton
        ref={ref}
        variant={variant}
        className={cn(
          'cursor-pointer',
          variant === 'link' && 'text-link',
          className,
        )}
        {...props}
      />
    )
  },
)
Button.displayName = 'Button'

export { Button, type ButtonProps, buttonVariants }
